// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminVendorApiKeyMappings = (client) => ({
    /**
     * `GET /admin/vendor-api-key-mappings/scheduled-revocations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListScheduledPublishableKeyRevocations
     * @source apps/backend/src/api/admin/vendor-api-key-mappings/scheduled-revocations/route.ts
     */
    listScheduledRevocations: (query, headers) => client.fetch("/admin/vendor-api-key-mappings/scheduled-revocations", { method: "GET", query, headers }),
});
//# sourceMappingURL=vendor-api-key-mappings.js.map